/**
 * Tiny axios wrapper for the Bible Games endpoints. Cookie-auth flows through
 * `withCredentials: true` (matches the rest of Lumera).
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const cfg = { withCredentials: true };

export const fetchTriviaDaily = (language = 'en') =>
  axios.get(`${BACKEND_URL}/api/games/trivia/daily`, { ...cfg, params: { language } }).then((r) => r.data);

export const submitTrivia = (answers) =>
  axios.post(`${BACKEND_URL}/api/games/trivia/submit`, { answers }, cfg).then((r) => r.data);

export const fetchTriviaBonus = () =>
  axios.post(`${BACKEND_URL}/api/games/trivia/bonus`, {}, cfg).then((r) => r.data);

export const fetchScrambleDaily = (language = 'en') =>
  axios.get(`${BACKEND_URL}/api/games/scramble/daily`, { ...cfg, params: { language } }).then((r) => r.data);

export const submitScramble = (id, ordered) =>
  axios.post(`${BACKEND_URL}/api/games/scramble/submit`, { id, ordered }, cfg).then((r) => r.data);

export const fetchWhoSaidDaily = (language = 'en') =>
  axios.get(`${BACKEND_URL}/api/games/whosaidit/daily`, { ...cfg, params: { language } }).then((r) => r.data);

export const submitWhoSaid = (answers) =>
  axios.post(`${BACKEND_URL}/api/games/whosaidit/submit`, { answers }, cfg).then((r) => r.data);

export const fetchMyStats = () =>
  axios.get(`${BACKEND_URL}/api/games/me`, cfg).then((r) => r.data);

export const fetchLeaderboard = (period = 'all', limit = 20) =>
  axios.get(`${BACKEND_URL}/api/games/leaderboard`, { ...cfg, params: { period, limit } })
    .then((r) => r.data);
